/* d0cc41d0d61abddfb5a67b333d4aaa2e328c6034
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BssPopupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BssPopupsQuery = { __typename?: 'Query', bssPopups?: { __typename?: 'BssPopups', items?: Array<{ __typename?: 'BssPopup', popup_content?: string | null, popup_css?: string | null, popup_name?: string | null, popup_url?: string | null } | null> | null } | null };


export const BssPopupsDocument = gql`
    query BssPopups {
  bssPopups {
    items {
      popup_content
      popup_css
      popup_name
      popup_url
    }
  }
}
    `;

/**
 * __useBssPopupsQuery__
 *
 * To run a query within a React component, call `useBssPopupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBssPopupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBssPopupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBssPopupsQuery(baseOptions?: Apollo.QueryHookOptions<BssPopupsQuery, BssPopupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BssPopupsQuery, BssPopupsQueryVariables>(BssPopupsDocument, options);
      }
export function useBssPopupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BssPopupsQuery, BssPopupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BssPopupsQuery, BssPopupsQueryVariables>(BssPopupsDocument, options);
        }
export function useBssPopupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BssPopupsQuery, BssPopupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BssPopupsQuery, BssPopupsQueryVariables>(BssPopupsDocument, options);
        }
export type BssPopupsQueryHookResult = ReturnType<typeof useBssPopupsQuery>;
export type BssPopupsLazyQueryHookResult = ReturnType<typeof useBssPopupsLazyQuery>;
export type BssPopupsSuspenseQueryHookResult = ReturnType<typeof useBssPopupsSuspenseQuery>;
export type BssPopupsQueryResult = Apollo.QueryResult<BssPopupsQuery, BssPopupsQueryVariables>;